<template>
  <div class="rank-container">
    <div class="section-title">
      <i class="fas fa-chart-line"></i> 批文关注度排行榜
    </div>
    <ul class="rank-list">
      <li v-for="(item, index) in rankings.slice(0, 10)" :key="index"
          class="rank-item" :class="'rank-' + (index + 1)"
          @click="goToDetail(item.id)"
          >
          <a class="custom-link-black">
        <div class="rank-number">{{ index + 1 }}</div>
        <div class="rank-title">{{ item.titile }}</div>
        <div class="rank-views">
          <i class="fas fa-eye"></i> 热度：{{ item.views }}
        </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToDetail = (id) => {
  const route = router.resolve({ name: 'PwzrDetail', params: { id } })
  window.open(route.href, '_blank')
}

defineProps({
  rankings: {
    type: Array,
    default: () => []
  }
})
</script>

<style scoped>
.custom-link-black {
  text-decoration: none;
  color: rgb(6, 6, 6);
}
.rank-container {
  flex: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  padding: 25px;
  height: fit-content;
}

.section-title {
  font-size: 22px;
  color: #0056b3;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #eaeaea;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 10px;
  color: #0083c9;
}

.rank-list {
  list-style: none;
  margin-top: 15px;
}

.rank-item {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s;
  cursor: pointer;
}

.rank-item:hover {
  background: #f0f8ff;
}

.rank-number {
  width: 24px;
  height: 24px;
  background: #e6f2ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 14px;
  color: #0056b3;
  font-weight: bold;
}

.rank-1 .rank-number {
  background: #ffd700;
}

.rank-2 .rank-number {
  background: #c0c0c0;
}

.rank-3 .rank-number {
  background: #cd7f32;
}

.rank-title {
  flex: 1;
  font-size: 15px;
}

.rank-views {
  color: #888;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.rank-views i {
  margin-right: 5px;
}
</style>
